/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Peter Y (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";

// react-router-dom components
// import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
// import Grid from "@mui/material/Grid";
// import MuiLink from "@mui/material/Link";

// @mui icons
// import FacebookIcon from "@mui/icons-material/Facebook";
// import GitHubIcon from "@mui/icons-material/GitHub";
// import GoogleIcon from "@mui/icons-material/Google";
import {useNavigate} from 'react-router-dom';
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";
// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
// react redux
import { useDispatch } from "react-redux";
import { authLogin } from "../../../store/actions/auth";
// import * as actionTypes from "../../../store/actions/actionTypes"
const Basic = () => {
  const savedRemember = localStorage.getItem("admin-rememberMe") === "true";
  const [rememberMe, setRememberMe] = useState(savedRemember);
  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState("");
  const [useremail, setUserEmail] = useState("");
  const [userpwd, setUserPwd] = useState("");

  // Restore saved credentials on mount
  useEffect(() => {
    if (savedRemember) {
      const savedEmail = localStorage.getItem("admin-savedEmail") || "";
      const savedPwd = localStorage.getItem("admin-savedPwd") || "";
      setUserEmail(savedEmail);
      setUserPwd(savedPwd);
    }
  }, []);

  const updateEmail = (e)=>{
    setUserEmail(e.target.value);
  }
  const updatePassword = (e)=>{
    setUserPwd(e.target.value);
  }
  const dispatch = useDispatch();
  const history = useNavigate();

  const signIn = () => {
    setFormError("");
    if (!useremail) { setFormError("Please enter your email"); return; }
    if (!userpwd) { setFormError("Please enter your password"); return; }

    // Save or clear credentials based on Remember Me
    if (rememberMe) {
      localStorage.setItem("admin-savedEmail", useremail);
      localStorage.setItem("admin-savedPwd", userpwd);
      localStorage.setItem("admin-rememberMe", "true");
    } else {
      localStorage.removeItem("admin-savedEmail");
      localStorage.removeItem("admin-savedPwd");
      localStorage.removeItem("admin-rememberMe");
    }

    setLoading(true);
    dispatch(authLogin(useremail, userpwd, rememberMe, (res)=>{
      setLoading(false);
      if(res.status === 200)
        history('/dashboard')
    }))
  }

  return (
    <BasicLayout image={bgImage}>
      <Card>        
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Artesis & WisysPro
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={(e) => { e.preventDefault(); signIn(); }}>
            <MDBox mb={2}>
              <MDInput type="email" label="Email" value={useremail} onChange={updateEmail} fullWidth />
            </MDBox>
            <MDBox mb={2}>
              <MDInput type="password" label="Password" value={userpwd}  onChange={updatePassword} fullWidth />
            </MDBox>
            {formError && (
              <MDTypography variant="caption" color="error" textAlign="center" display="block" mb={1}>
                {formError}
              </MDTypography>
            )}
            <MDBox display="flex" alignItems="center" ml={-1}>

              <Switch checked={rememberMe} onChange={handleSetRememberMe} inputProps={{ 'aria-label': 'Remember me' }} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                component="label"
                onClick={handleSetRememberMe}
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Remember me
              </MDTypography>

            </MDBox>

            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="info" fullWidth onClick={signIn} disabled={loading}>
                {loading ? <CircularProgress size={20} color="inherit" /> : "sign in"}
              </MDButton>
            </MDBox>     

          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
